import styled from 'styled-components';

export const WrapperPreguntaEncuestaInput = styled.div`
  .contadorCaracteres {
    font-size: 0.7rem;
    color: #646569;
    position: relative;
    float: right;
    top: -12px;
  }
`;

export default WrapperPreguntaEncuestaInput;